/* Bidameun — Agregar al carrito desde la home (v13, 22-07-2026) */
(function(){
  var sb = document.getElementById('stickybar');
  function activarBolsa(){
    if(!sb) return;
    sb.classList.add('on','has-cart');
    var p = sb.querySelector('p'), a = sb.querySelector('.btn');
    if(p) p.innerHTML = 'Producto agregado. <b>Envío gratis desde $397 (Edo. Mex. y CDMX)</b>';
    if(a){ a.textContent = 'Ver mi bolsa'; a.setAttribute('href','/cart'); }
  }
  document.querySelectorAll('.bida .pcard__add--btn').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if(b.dataset.busy) return;
      b.dataset.busy = '1';
      var old = b.textContent;
      b.textContent = 'Agregando…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id: Number(b.dataset.vid), quantity: 1}]})
      })
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ b.textContent = '✓ Agregado'; b.classList.add('is-ok'); activarBolsa(); })
      .catch(function(){ b.textContent = 'No se pudo'; })
      .then(function(){ setTimeout(function(){ b.textContent = old; b.classList.remove('is-ok'); b.dataset.busy = ''; }, 2600); });
    });
  });
})();